define(["app/app"], app => {
  app.register.controller("login", LoginController);
  LoginController.$inject = ["$scope", "$rootScope", "auth", "$location", "data", "$sce"];
  function LoginController($scope, $rootScope, auth, $location, data, $sce) {
    function clearMessages() {
      $scope.message = null;
      $scope.error = null;
    }

    $scope.login = async function login(email, password) {
      if (!email && !password) {
        return;
      }

      clearMessages();
      $("#login button[type='submit']").attr("disabled", "disabled");

      try {
        await auth.doAuth(email, password);
      } catch (err) {
        const { data } = err;

        console.error("Error during login request", err);

        if (data.type === "authz" && data.message === "Password Expired" && data.userId && data.key) {
          $scope.userid = data.userId;
          $scope.resetkey = data.key;
          $("#login").modal("hide");
          $("#reset").modal({ backdrop: false, keyboard: false });
          $scope.expired = true;

          setTimeout(() => $scope.$apply(), 10);
          return;
        }

        $("#login button[type='submit']").removeAttr("disabled");
        $("#login input[name='password']").val("");
        $scope.error = { type: data.type, message: data.message };

        setTimeout(() => $scope.$apply(), 10);
        return;
      }

      //If we have a redirect path, redirect there.
      $rootScope.redirectWithToken(true);

      $("#login button[type='submit']").removeAttr("disabled");

      $("#login").modal("hide");
      $("body").removeClass("modal-open");
      $(".modal-backdrop").remove();
      delete $location.$$search;
      const returnTo = localStorage.getItem("returnTo");
      if (returnTo) {
        localStorage.removeItem("returnTo");
        $rootScope.setPath(returnTo);
      } else if (!$scope.isActivated()) {
        $rootScope.setPath("/application");
      } else {
        $rootScope.setPath("/dashboard");
      }

      $scope.trackEvent("myAccount_", "Logged In");

      // fire post-login function (defined in app.core.js)
      $rootScope.afterLogin();

      setTimeout(() => $scope.$apply(), 10);
    };

    $scope.register = async function register(username, email) {
      if (!username && !email) {
        return;
      }

      clearMessages();
      $("#signup button[type='submit']").attr("disabled", "disabled");

      try {
        await auth.register({ username, emailAddress: email });
      } catch (err) {
        console.error(err);
        $("#signup button[type='submit']").removeAttr("disabled");
        $scope.error = err.data.message;

        setTimeout(() => $scope.$apply(), 10);
        return;
      }

      $("#signup button[type='submit']").removeAttr("disabled");
      $scope.message = "Registration successful. Activation email sent.";

      setTimeout(() => $scope.$apply(), 10);
    };

    $scope.trustAsHtml = function trustAsHtml(code) {
      return $sce.trustAsHtml(code);
    };

    $scope.showLogin = function showLogin(message) {
      if (message === "welcome") {
        data.getWelcomeMessage().then(res => {
          $scope.welcomeMessage = res.data;
          clearMessages();
          $scope.help = false;
          $("#login").modal({ backdrop: false, keyboard: false });
        });
      } else {
        clearMessages();
        $scope.help = false;
        $("#login").modal({ backdrop: false, keyboard: false });
      }
    };

    $scope.showSignup = function showSignup() {
      clearMessages();
      $("#signup").modal();
    };

    $scope.activate = async function activate(pw, pw2) {
      if (!pw) {
        return;
      }

      clearMessages();
      $("#activate button[type='submit']").attr("disabled", "disabled");
      const userid = $scope.userid;
      const key = $scope.key;

      if (pw !== pw2) {
        $scope.error = "Passwords do not match";
      } else if (pw.length < 7) {
        $scope.error = "Password must contain at least 8 characters";
      } else if (pw.match(/[0-9]/) === null) {
        $scope.error = "Password must contain at least one number";
      } else if (pw.match(/[A-z]/) === null) {
        $scope.error = "Password must contain at least one letter";
      }

      if ($scope.error) {
        $("#activate button[type='submit']").removeAttr("disabled");
        setTimeout(() => $scope.$apply(), 10);
        return;
      }

      let res;
      try {
        res = await auth.activate(userid, pw, key);
      } catch (err) {
        $("#activate button[type='submit']").removeAttr("disabled");
        console.error("Error activating account");
        $scope.error = err.data.message;
      }

      $("#activate button[type='submit']").removeAttr("disabled");

      try {
        await $scope.login(res.data.email, pw);
      } catch (err) {
        console.error(err);
      }

      setTimeout(() => $scope.$apply(), 10);
    };

    $scope.requestReset = async function passwordRequestReset(email) {
      if (!email) {
        return;
      }

      clearMessages();
      $("button#reqreset").attr("disabled", "disabled");

      let res;
      try {
        res = await auth.requestreset(email);
      } catch (err) {
        $scope.error = err.data.message;
        console.error("Error requesting password reset");
        $("button#reqreset").removeAttr("disabled");

        setTimeout(() => $scope.$apply(), 10);
        return;
      }

      $scope.message = res.data.message;
      $("button#reqreset").removeAttr("disabled");

      setTimeout(() => $scope.$apply(), 10);
    };

    $scope.reset = async function resetPassword(pw, pw2) {
      if (!pw) {
        return;
      }

      if (pw !== pw2) {
        $scope.error = "Passwords do not match";
        return;
      }

      clearMessages();
      $("#reset button[type='submit']").attr("disabled", "disabled");

      if ($scope.error) {
        $("#reset button[type='submit']").removeAttr("disabled");
        return;
      }

      let res;
      try {
        res = await auth.reset($scope.userid, pw, $scope.resetkey);
      } catch (err) {
        $("#reset button[type='submit']").removeAttr("disabled");
        console.error("Error resetting password");
        $scope.error = err.data.message;

        setTimeout(() => $scope.$apply(), 10);
        return;
      }

      try {
        await $scope.login(res.data.email, pw);
      } catch (err) {
        console.error(err);
      }

      setTimeout(() => $scope.$apply(), 10);
    };

    $scope.resend = async function resend(email) {
      if (!email) {
        return;
      }

      clearMessages();
      $("button#resend").attr("disabled", "disabled");

      let res;
      try {
        res = await auth.resend(email);
      } catch (err) {
        $("button#resend").removeAttr("disabled");
        console.error("Error resending activation email");
        $scope.error = err.data.message;

        setTimeout(() => $scope.$apply(), 10);
        return;
      }

      $("button#resend").removeAttr("disabled");
      $scope.message = res.data.message;

      setTimeout(() => $scope.$apply(), 10);
    };

    $scope.$on("$routeChangeSuccess", (event, route) => {
      auth.logout();
      if (route.params.user_id) {
        $scope.userid = route.params.user_id;
        if (route.params.key) {
          $scope.key = route.params.key;
          $("#activate").modal({ backdrop: false, keyboard: false });
        } else if (route.params.resetkey) {
          if (route.params.publisher_id) $scope.returnTo = "/publisher/" + route.params.publisher_id;
          $scope.resetkey = route.params.resetkey;
          $("#reset").modal({ backdrop: false, keyboard: false });
        }
      } else {
        $scope.showLogin(route.params.msg);
      }
    });
  }
});
